import { client } from "./index";

// Blog posts. ownezzy.com's (Super Admin): /admin/blog. A store's: /admin/sites/:siteId/blog.
// Each returns the same calls, so one editor (pages/admin/BlogManager.js) works for both.
const calls = (base) => ({
  list: () => client.get(base).then((res) => res.data.posts),
  create: (post) => client.post(base, post).then((res) => res.data),
  update: (id, post) => client.put(`${base}/${id}`, post).then((res) => res.data),
  remove: (id) => client.delete(`${base}/${id}`).then((res) => res.data),
});

export const ownezzyBlog = {
  ...calls("/admin/blog"),
  // Covers of ownezzy.com's posts are kept with Ownezzy's platform images
  uploadCover: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return client.post("/admin/blog/cover", formData, { params: { kind: "banner" } }).then((res) => res.data.url);
  },
};

export const storeBlog = (siteId) => calls(`/admin/sites/${siteId}/blog`);
